// extracted by mini-css-extract-plugin
export default {"broadcastReport":"styles_broadcastReport__9oetO","broadcastReport_label":"styles_broadcastReport_label__hKEmN","broadcastReport_button":"styles_broadcastReport_button__OfVCR"};